import type { SxProps, Theme } from '@mui/material';

export const filterBarButtonSx: SxProps<Theme> = {
  height: 36,
  width: 36,
};
